import type { CardType } from 'lib-shared-types-api';

/** External card types */
export type CardTypeExternal = Exclude<CardType, 'custom'>;

export const cardV2 = '2';
